import { gql } from '@apollo/client';
import { Locale } from 'modules/domains/template';

export type LocaleSettings = {
  locales: Locale[];
  isTemplateDefaultLocaleModifiable: boolean;
};

export type FetchLocalesSettingsResponse = {
  localeSettings: LocaleSettings;
};

export type FetchLocalesResponse = {
  locales: Locale[];
};

export const fetchLocalesQuery = gql`
  query getLocales {
    locales {
      languageName
      tag
      mappedWhatsAppInfobipLanguage
    }
  }
`;

export const fetchLocalesSettings = gql`
  query getLocaleSettings {
    localeSettings {
      __typename
      ... on LocaleSettingsResponse {
        isTemplateDefaultLocaleModifiable
        locales {
          tag
          languageName
          mappedWhatsAppInfobipLanguage
        }
        whatsAppLocales {
          invalidWhatsAppLocales {
            languageName
            tag
          }
          validWhatsAppLocales {
            languageName
            tag
          }
        }
      }
    }
  }
`;

export const updateDefaultLocaleMutation = gql`
  mutation UpdateTemplateDefaultLocale(
    $templateId: Long!
    $locale: TemplateLocaleInput!
  ) {
    changeTemplateDefaultLocale(templateId: $templateId, locale: $locale) {
      failures {
        ... on LocaleNotFound {
          locale
        }
      }
      ... on TemplateLocalesResponse {
        templateId
        defaultLocale {
          tag
        }
      }
    }
  }
`;

export const queryTemplateAndProjectLocales = gql`
  query getTemplateAndProjectLocales($templateId: Long!) {
    templateAndProjectLocales(templateId: $templateId) {
      ... on TemplateAndProjectLocaleData {
        templateId
        activeTemplateLocales {
          ... on Locale {
            languageName
            tag
          }
        }
        allProjectLocales {
          ... on Locale {
            languageName
            tag
          }
        }
        templateDefaultLocale {
          languageName
          tag
        }
      }
      ... on WhatsAppTemplateLocalesData {
        templateId
        templateDefaultLocale {
          languageName
          tag
        }
        activeWhatsAppTemplateLocales: activeTemplateLocales {
          qualityRating
          metaApprovalStatus
          locale {
            ... on Locale {
              languageName
              tag
            }
          }
        }
        allProjectLocales {
          ... on Locale {
            languageName
            tag
          }
        }
        validWhatsAppLocales {
          languageName
          tag
        }
        invalidWhatsAppLocales {
          languageName
          tag
        }
      }
    }
  }
`;

export const fetchIsWhatsAppInfobipLocaleUsed = gql`
  query isWhatsAppInfobipLocaleUsedQuery($locale: String!) { 
    isWhatsAppInfobipLocaleUsed(locale: $locale) 
  }
`;
